const DEFAULT_SCOUT_LOGIN_PAGE = 'https://sso.immobilienscout24.de/sso/login';
const KYB_APP_NAME = 'kyb';
const DSA_VERIFICATION_RETURN_PATH = '/dsa-verification';

export function getLoginUrl(returnUrl: string) {
  const scoutLoginPage = process.env.SCOUT_LOGIN_PAGE || DEFAULT_SCOUT_LOGIN_PAGE;

  return encodeURI(`${scoutLoginPage}?appName=${KYB_APP_NAME}&sso_return=${returnUrl}`);
}

export function getDsaVerificationReturnUrl() {
  return new URL(DSA_VERIFICATION_RETURN_PATH, process.env.BASE_URL || window.location.origin).toString();
}

export function toLogin() {
  toUrl(getLoginUrl(getDsaVerificationReturnUrl()));
}

export function toUrl(url: string) {
  window.location.assign(url);
}
